import * as AT from '../actions/_types'

const resetState = () => ({
  id: null,
  isFetching: false,
  location: null,
  patient: {},
  accountHolders: [],
  relatedPatients: [],
  groupsIds: [],
  appointments: [],
  reviews: [],
  messages: {
    emailConversationIds: [],
    textConversationIds: [],
    isFetching: false,
  },
  notes: [],
  payments: [],
})

export default function selectedPatient(prevState = resetState(), action) {
  switch (action.type) {
    case AT.PATIENT_SELECT_RESET: {
      return {
        ...resetState(),
      }
    }
    case AT.PATIENT_SELECT_REQUEST: {
      return {
        ...resetState(),
        id: action.patientId,
        isFetching: true,
      }
    }
    case AT.PATIENT_SELECT_REQUEST_SUCCESS: {
      return {
        ...prevState,
        isFetching: false,
        ...action.patientUpdate,
      }
    }
    case AT.PATIENT_SELECT_REQUEST_FAILURE: {
      return {
        ...prevState,
        isFetching: false,
      }
    }
    case AT.PATIENT_APPOINTMENTS: {
      return {
        ...prevState,
        appointments: action.appointments,
      }
    }
    case AT.PATIENT_REVIEWS: {
      return {
        ...prevState,
        reviews: action.reviews,
      }
    }
    case AT.PATIENT_CONVERSATION_REQUEST:
    case AT.PATIENT_CONVERSATION_REQUEST_SUCCESS:
    case AT.PATIENT_CONVERSATION_REQUEST_FAILURE: {
      return {
        ...prevState,
        messages: reducePatientConversationMessages(prevState.messages, action),
      }
    }
    case AT.PATIENT_ADD_MSG_CONTACT_INFO: {
      const { contactInfo, locationPhone } = action
      const { patient: oldPatient } = prevState
      const patient = {
        ...oldPatient,
        preferred_contact_info: contactInfo,
        location_phone_number: locationPhone,
      }
      return {
        ...prevState,
        patient,
      }
    }
    case AT.PATIENT_UPDATE_CONVERSATION_IDS: {
      const { conversationId, convosIdKey } = action
      const { messages: oldMessages } = prevState
      const messages = { ...oldMessages }
      if (!messages[convosIdKey].includes(conversationId)) {
        messages[convosIdKey].push(conversationId)
      }
      return {
        ...prevState,
        messages,
      }
    }
    case AT.PATIENT_NOTES_RECEIVE:
    case AT.PATIENT_NOTES_CREATE:
    case AT.PATIENT_NOTES_UPDATE:
    case AT.PATIENT_NOTES_DELETE: {
      return {
        ...prevState,
        notes: reducePatientNotes(prevState.notes, action),
      }
    }

    default: {
      return prevState
    }
  }
}

function reducePatientConversationMessages(
  prevState = resetState().messages,
  action,
) {
  switch (action.type) {
    case AT.PATIENT_CONVERSATION_REQUEST: {
      return {
        ...prevState,
        isFetching: true,
      }
    }
    case AT.PATIENT_CONVERSATION_REQUEST_SUCCESS: {
      return {
        ...prevState,
        isFetching: false,
        emailConversationIds: action.emailConversationIds,
        textConversationIds: action.textConversationIds,
      }
    }
    case AT.PATIENT_CONVERSATION_REQUEST_FAILURE: {
      return {
        ...prevState,
        isFetching: false,
      }
    }
    default: {
      return prevState
    }
  }
}

function reducePatientNotes(prevState, action) {
  switch (action.type) {
    case AT.PATIENT_NOTES_RECEIVE: {
      return action.notes
    }
    case AT.PATIENT_NOTES_CREATE: {
      return prevState.concat(action.newNote)
    }
    case AT.PATIENT_NOTES_UPDATE: {
      return [
        ...prevState.slice(0, action.index),
        action.updatedNote,
        ...prevState.slice(action.index + 1),
      ]
    }
    case AT.PATIENT_NOTES_DELETE: {
      return [
        ...prevState.slice(0, action.index),
        ...prevState.slice(action.index + 1),
      ]
    }

    default: {
      return prevState
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/selected-patient.js